import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { installViewportFix } from './utils/viewportFix';
import { initInstallTracking } from './utils/installState';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<App />);

// 禁止页面缩放：顶栏 / 底栏是 position: fixed，页面一旦被放大（双指捏合，或 iOS 聚焦小字号输入框时的自动放大），
// 它们就会留在原位、看起来像是“跟着页面跑”。iOS Safari 会忽略 viewport 的 user-scalable=no，所以要拦截 gesture 事件。
['gesturestart', 'gesturechange', 'gestureend'].forEach(evt =>
  document.addEventListener(evt, e => e.preventDefault(), { passive: false })
);

// iOS 26 键盘收起后 visualViewport 偏移不归零导致顶栏 / 底栏错位的补偿（见 utils/viewportFix.js）
installViewportFix();

// 记录“已装成 App”的标记，安装引导据此不再重复弹出（见 utils/installState.js）
initInstallTracking();
